import Icon from '@components/v2/ui/Icon/Icon';
import { Receipt } from 'lucide-react';
import useMoney from '../../../../../../hooks/useMoney';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { InvoiceSearchResultItem } from '../../../../globalSearch.types';
import HighlightedText from '../../../HighlightedText';
import ResultRowBase from '../../ResultRowBase';
import { ResultRowRendererProps } from '../../resultRow.types';
import { formatOptionalMoney, joinResultParts } from '../../resultRow.utils';

function InvoiceRow({
  item,
  query,
  isActive,
  isDisabled,
  domId,
  onSelect,
}: ResultRowRendererProps<InvoiceSearchResultItem>) {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();

  const title = translate(LangEnum.GLOBAL_SEARCH_INVOICE_TITLE, { code: item.code });
  const subtitle = joinResultParts([
    formatOptionalMoney(item.grossValue, formatMoney),
    item.customerName,
  ]);

  return (
    <ResultRowBase
      testId={`global-search-item-${item.entityType}-${item.id}`}
      isActive={isActive}
      isDisabled={isDisabled}
      domId={domId}
      onClick={onSelect}
      leading={<Icon icon={Receipt} size="md" />}
      title={<HighlightedText text={title} query={query} />}
      subtitle={subtitle ? <HighlightedText text={subtitle} query={query} /> : undefined}
    />
  );
}

export default InvoiceRow;
